/* FIRGELLI navigation tracking v1. Storefront publisher only; Shopify pixel forwards to GA4. */
(function () {
  'use strict';
  if (window.__firgelliNavigationTrackingV1) return;
  window.__firgelliNavigationTrackingV1 = true;

  var CLICK_EVENT = 'firgelli:navigation_click';
  var OPEN_EVENT = 'firgelli:navigation_open';
  var openedMenus = new Set();
  var pendingMenus = new Set();
  var mobileObserver;
  var mobileIntentUntil = 0;
  var privacyLoadStarted = false;
  var privacyLoadReady = false;
  var privacyLoadFailed = false;
  var privacyLoadAttempts = 0;

  function text(value) {
    return String(value || '').replace(/\s+/g, ' ').trim().slice(0, 100);
  }

  function privacyApiPresent() {
    return !!(window.Shopify && Shopify.customerPrivacy &&
      typeof Shopify.customerPrivacy.analyticsProcessingAllowed === 'function');
  }

  function loadPrivacyApi() {
    if (privacyLoadStarted || privacyLoadFailed || privacyApiPresent()) return;
    if (!window.Shopify || typeof Shopify.loadFeatures !== 'function') {
      privacyLoadAttempts += 1;
      if (privacyLoadAttempts < 8) window.setTimeout(loadPrivacyApi, 250);
      return;
    }
    privacyLoadStarted = true;
    try {
      Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], function (error) {
        privacyLoadFailed = !!error;
        privacyLoadReady = !error && privacyApiPresent();
        // Loading the API neither changes consent nor replays an earlier interaction.
      });
    } catch (ignore) {
      privacyLoadFailed = true;
    }
  }

  function analyticsAllowed() {
    try {
      if (privacyLoadFailed || (privacyLoadStarted && !privacyLoadReady)) return false;
      return !!(privacyApiPresent() &&
        Shopify.customerPrivacy.analyticsProcessingAllowed() === true);
    } catch (ignore) {
      return false;
    }
  }

  function publish(name, data) {
    // No queue: interactions before analytics permission is available are not replayed.
    if (!analyticsAllowed() || !window.Shopify || !Shopify.analytics ||
        typeof Shopify.analytics.publish !== 'function') return false;
    try {
      return Shopify.analytics.publish(name, data) !== false;
    } catch (ignore) {
      return false;
    }
  }

  function safePath(anchor) {
    try {
      var href = anchor.getAttribute('href');
      if (!href || href.charAt(0) === '#') return '';
      var url = new URL(href, window.location.href);
      if (url.origin !== window.location.origin || url.username || url.password) return '';
      var path = url.pathname;
      if (!/^\/(collections|products|pages|blogs)(\/|$)/.test(path)) return '';
      if (/^\/pages\/contact(?:-us)?(?:\/|$)/i.test(path)) return '';
      if (path.length > 200 || /@|%40/i.test(path)) return '';
      return path; // Query strings and fragments are intentionally never published.
    } catch (ignore) {
      return '';
    }
  }

  function visible(node) {
    if (!node || node.isConnected === false || document.hidden) return false;
    for (var current = node; current && current.nodeType === 1; current = current.parentElement) {
      var style = window.getComputedStyle(current);
      if (current.hidden || style.display === 'none' || style.visibility === 'hidden' ||
          style.visibility === 'collapse' || Number(style.opacity) === 0) return false;
    }
    var rect = node.getBoundingClientRect();
    var width = window.innerWidth || document.documentElement.clientWidth;
    var height = window.innerHeight || document.documentElement.clientHeight;
    return rect.width > 0 && rect.height > 0 && rect.right > 0 && rect.bottom > 0 &&
      rect.left < width && rect.top < height;
  }

  function directChild(node, tagName) {
    if (!node) return null;
    for (var i = 0; i < node.children.length; i += 1) {
      if (node.children[i].tagName === tagName) return node.children[i];
    }
    return null;
  }

  function topChild(node, list) {
    while (node && node.parentElement !== list) node = node.parentElement;
    return node && node.tagName === 'LI' ? node : null;
  }

  function desktopContext(node) {
    if (!node || !node.closest) return null;
    var nav = node.closest('nav.firgelli-third-row');
    var list = node.closest('ul.firgelli-third-row__list');
    if (!nav || !list || !nav.contains(list)) return null;
    var item = topChild(node, list);
    var label = directChild(item, 'A');
    if (!item || !label) return null;
    return { name: text(label.textContent), location: 'desktop', scope: item,
      submenu: directChild(item, 'UL') };
  }

  function mobileRoot(node) {
    if (!node || !node.closest) return null;
    var list = node.closest('.fg-mobile-nav-list');
    var drawer = node.closest('#offcanvas-nav-primary');
    return list && drawer && drawer.contains(list) ? list : null;
  }

  function mobileContext(node) {
    var root = mobileRoot(node);
    if (!root) return null;
    var list = node.closest('ul');
    if (!list || !root.contains(list)) return null;
    var label = list !== root ? directChild(list.parentElement, 'A') : null;
    return { name: label ? text(label.textContent) : 'Main navigation',
      location: 'mobile', scope: list, submenu: list };
  }

  function openMenu(context) {
    if (!context || !context.name || !context.submenu || !visible(context.submenu)) return;
    var key = context.location + ':' + context.name;
    if (openedMenus.has(key)) return;
    if (publish(OPEN_EVENT, { tracking_version: 'nav_v1', menu_name: context.name,
      menu_location: context.location })) openedMenus.add(key);
  }

  function scheduleOpen(context) {
    if (!context || !context.submenu || !analyticsAllowed()) return;
    var key = context.location + ':' + context.name;
    if (openedMenus.has(key) || pendingMenus.has(key)) return;
    pendingMenus.add(key);
    // CSS hover applies immediately; UIKit accordion/drawer transitions can finish later.
    [0, 150, 400].forEach(function (delay, index) {
      window.setTimeout(function () {
        openMenu(context);
        if (index === 2) pendingMenus.delete(key);
      }, delay);
    });
  }

  function inspectMobile() {
    if (Date.now() > mobileIntentUntil) return;
    if (!analyticsAllowed()) return;
    Array.prototype.forEach.call(document.querySelectorAll('#offcanvas-nav-primary .fg-mobile-nav-list'), function (root) {
      if (!visible(root)) return;
      scheduleOpen({ name: 'Main navigation', location: 'mobile', scope: root, submenu: root });
      Array.prototype.forEach.call(root.querySelectorAll('ul'), function (list) {
        var label = directChild(list.parentElement, 'A');
        if (label && visible(list)) scheduleOpen({ name: text(label.textContent),
          location: 'mobile', scope: list, submenu: list });
      });
    });
  }

  function onIntent(event) {
    if (event.isTrusted === false || !analyticsAllowed()) return;
    var target = event.target;
    if (!target || !target.closest) return;
    var desktop = desktopContext(target);
    if (desktop) scheduleOpen(desktop);
    if (mobileRoot(target)) {
      mobileIntentUntil = Date.now() + 1000;
      inspectMobile();
    }
  }

  function onClick(event) {
    if (event.isTrusted === false || event.defaultPrevented || !analyticsAllowed()) return;
    if (event.type === 'auxclick' ? event.button !== 1 : event.button !== 0) return;
    var target = event.target;
    if (!target || !target.closest) return;
    var toggle = target.closest('a, button');
    if (toggle && (toggle.getAttribute('href') === '#offcanvas-nav-primary' ||
        String(toggle.getAttribute('uk-toggle') || '').indexOf('offcanvas-nav-primary') !== -1)) {
      mobileIntentUntil = Date.now() + 1000;
      window.setTimeout(inspectMobile, 0);
      window.setTimeout(inspectMobile, 400);
    }
    var anchor = target.closest('a');
    if (!anchor) return;
    var context = desktopContext(anchor) || mobileContext(anchor);
    if (!context || !visible(anchor)) return;
    openMenu(context);
    scheduleOpen(context);
    if (context.location === 'mobile') {
      mobileIntentUntil = Date.now() + 1000;
      // The click can expand a UIKit accordion after this capture listener returns.
      window.setTimeout(inspectMobile, 0);
      window.setTimeout(inspectMobile, 400);
      // UIKit's uk-parent > a is an accordion control even when Liquid gives it
      // a collection URL. Its normal click expands the menu rather than navigating.
      var parent = anchor.parentElement;
      if (event.type === 'click' && parent && parent.matches('li.uk-parent') &&
          directChild(parent, 'A') === anchor && directChild(parent, 'UL')) return;
    }
    var path = safePath(anchor);
    if (!path || !analyticsAllowed()) return;
    var anchors = Array.prototype.filter.call(context.scope.querySelectorAll('a'), function (item) {
      return !!safePath(item);
    });
    publish(CLICK_EVENT, { tracking_version: 'nav_v1', menu_name: context.name,
      menu_location: context.location, link_text: text(anchor.textContent),
      link_path: path, link_position: anchors.indexOf(anchor) + 1 });
  }

  function observeMobile() {
    var drawer = document.querySelector('#offcanvas-nav-primary');
    if (!drawer || !window.MutationObserver || mobileObserver) return;
    mobileObserver = new MutationObserver(inspectMobile);
    mobileObserver.observe(drawer, { subtree: true, attributes: true,
      attributeFilter: ['class', 'style', 'hidden', 'aria-expanded', 'open'] });
  }

  document.addEventListener('pointerover', onIntent, true);
  document.addEventListener('focusin', onIntent, true);
  document.addEventListener('click', onClick, true);
  document.addEventListener('auxclick', onClick, true);
  loadPrivacyApi();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observeMobile, { once: true });
  else observeMobile();
})();
